<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        payload.filter();
    },
    methods:{
        filter: function(){  
        Request.do(this, 'POST', Request.getDefaultHeader(this), {  type: "SERVICE" }, `${Endpoints.parts.families.listByType}`,
        (response)=>{//SUCCESS CALLBACK
            this.items = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize
    }
}
</script>
